import { ISchemaDefinition } from ".";

export interface IPendingMutation {
    id: string;
    objectNamespace: string;
    objectId: string;
    revisionId: number;
    documentId: string;
    mutations: any[];
}
export const PendingMutationSchema: ISchemaDefinition = {
    collectionName: "pendingMutations",
    properties: [
        {
            key: "id",
            primary: true,
        },
        {
            key: "objectNamespace",
            index: true,
        },
        {
            key: "objectId",
            index: true,
        },
        {
            key: "revisionId",
            index: true,
        },
        {
            key: "documentId",
            index: true,
        },
        {
            key: "mutations",
        },
    ],
};
